export default __webpack_public_path__ + "9efdfef4a10670f6de692f6d887a5e22.svg";